import { useFormikContext } from 'formik';
import { useEffect, useRef } from 'react';
import useFetchWorkQueueMobileAnswers from 'App/hooks/useFetchWorkQueueMobileAnswers';
import { transformReactFilterToLS } from '../workQueue.utils';
import { useUserPreferences } from 'App/contexts/UserPreferencesContext';
import { FILTER_TYPE } from '../workQueue.constant';

function useMobileAnswersQueue(lazyFilter) {
    const {
        values,
        values: { filterType },
    } = useFormikContext();
    const { setPreference } = useUserPreferences();

    const { data: mobileAnswersComplete, isLoading: isSubmitting } = useFetchWorkQueueMobileAnswers(lazyFilter);
    const prevDataRef = useRef();

    useEffect(() => {
        // Only save to preferences when new data is fetched (not just when values change)
        if (mobileAnswersComplete && mobileAnswersComplete !== prevDataRef.current) {
            prevDataRef.current = mobileAnswersComplete;

            if (filterType !== FILTER_TYPE.ASSIGNMENT_MANAGER) {
                setPreference('workQueue_selectedFilter', transformReactFilterToLS(values));
            } else {
                setPreference('assignmentManager_selectedFilter', transformReactFilterToLS(values));
            }
        }
    }, [mobileAnswersComplete, filterType, values, setPreference]);

    return { data: mobileAnswersComplete, isLoading: isSubmitting };
}

export default useMobileAnswersQueue;
